export const MATERIAL_ATTRIBUTE_ID = 47617;
export const MATERIALS_ATTRIBUTE_ID = 32;
export const ORIGIN_ATTRIBUTE_ID = 535;
export const WEIGHT_ATTRIBUTE_ID = 7;

const CarbonScoreCalculationAttributeIds = [
  MATERIAL_ATTRIBUTE_ID,
  MATERIALS_ATTRIBUTE_ID,
  ORIGIN_ATTRIBUTE_ID,
  WEIGHT_ATTRIBUTE_ID,
];

export const isCarbonScoreAttribute = (attributeId: number) =>
  CarbonScoreCalculationAttributeIds.includes(attributeId);
